export default __webpack_public_path__ + "static/media/1128040325512738.1664edc3.jpg";